export const projectsParam = {
  filters: { sort_column: 'created_at', sort_order: 'desc' },
}

export const hubsParam = {
  filterable: true,
  per_page: 999,
  filters: { sort: { created_at: 'desc' } },
}
